/**
 * Module-level cache that holds the tenant slug resolved via hostname matching.
 *
 * The HostnameTenantProvider populates this store immediately after resolution
 * so that the apiClient 401 interceptor can build the correct login redirect
 * in matched-hostname mode (where the URL carries no slug prefix).
 */

let _matchedSlug = null;

/** Store the slug after successful hostname resolution. Pass null to clear. */
export const setResolvedTenant = (slug) => {
  _matchedSlug = slug || null;
};

/** Returns true when the hostname was resolved to a registered tenant. */
export const isHostnameMatched = () => _matchedSlug !== null;

/** Returns the matched slug, or null when in slug-prefixed mode. */
export const getMatchedSlug = () => _matchedSlug;

/**
 * Returns the login path appropriate for the current routing mode.
 * In matched mode the login path has no slug prefix ('/login').
 * In slug-prefixed mode returns null so the caller can fall back to the
 * slug-prefixed path.
 *
 * @returns {string|null}
 */
export const buildLoginPath = () => (isHostnameMatched() ? '/login' : null);
